import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputBase, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { GrNext } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";

import { TablePaginationActions } from '../../../helpers/TablePaginationActions';
import { usePages } from '../../../hooks/usePages';

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";
import { setReducerPartes } from '../../../store/slices/RecepcionSlice';

import { DialogNuevaPersona } from '../../../dialogs/DialogNuevaPersona';
import { DialogBuscarPersona } from '../../../dialogs/DialogBuscarPersona';

import { InputSearchButtonsStyle, InputSearchStyle } from '../../../styles/FormStyle';
import { TableTheadStyle, TablePaddingStyle } from '../../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';

import { ObtenerTipoParte } from '../../../connections/catalogos/TipoParteConnection';
import { ActualizarEstatus } from '../../../connections/comun/RecepcionConnection';
import { AgregarPartesAmparo, ObtenerPartesAmparo } from '../../../connections/comun/AmparoConnection';

import { TipoParteProps } from '../../../interfaces/catalogos/TipoParteInterface';
import { ParteProps, PersonaParteProps } from '../../../interfaces/comun/ParteInterface';
import { AgregarPartesAmparoParams } from '../../../interfaces/comun/AmparoInterface';

interface Props {
    numeroSeguimiento:      number;
    handleNext:             () => void;
    handleBack:             () => void;
}

export const RegistrarPartesPage = ({ numeroSeguimiento, handleNext, handleBack }: Props ) => {

    const dispatch = useDispatch();

    const recepcion = useSelector( ( state: RootState ) => state.recepcion );

    const [nuevaParte, setNuevaParte] = useState( false );
    
    const [tipoParte, setTipoParte] = useState(0);
    const [tipoParteArray, setTipoParteArray] = useState<TipoParteProps[]>( [] );

    const [tipoParteEdit, setTipoParteEdit] = useState(0);
    const [tipoParteEditArray, setTipoParteEditArray] = useState<TipoParteProps[]>( [] );

    const [openConfirmacion, setOpenConfirmacion] = useState(false);

    const [openEdit, setOpenEdit] = useState(false);

    const [rows, setRows] = useState<ParteProps[]>( [] );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );

    const [loadingBack, setLoadingBack] = useState(false);
    const [loadingNext, setLoadingNext] = useState(false);
    const [loadingSave, setLoadingSave] = useState( false );

    const [openDialogNuevaPersona, setopenDialogNuevaPersona] = useState(false);    
    const [openDialogBuscarPersona, setopenDialogBuscarPersona] = useState(false);

    const [idReferencia, setIdReferencia] = useState(0);
    const [idPersonaEdit, setIdPersonaEdit] = useState(0);

    const [parte, setParte] = useState( 0 );
    const [arrayParte, setArrayParte] = useState<ParteProps[]>( [] );

    const [{ idPersona, nombreCompleto, idTipoPersona }, setPersona] = useState<PersonaParteProps>( { idPersona: 0, nombreCompleto: '', idTipoPersona: 0, } );
    
    const seleccionarPersona = ( persona: PersonaParteProps ) => setPersona( persona );

    const validateFiels = () => {
            
        const quejoso = rows.filter( ( element ) => { return element.idTipoParte === 3 }).length;
        const autoridadResponsable = rows.filter( ( element ) => { return element.idTipoParte === 5 }).length;

        if ( quejoso === 0 || autoridadResponsable === 0 ){          
            
            dispatch( openSnackbar({ message: 'Debes agregar un quejoso y autoridad responsable', variant: 'warning' }));  
            return false;

        }

        return true;
    } 

    const handleClicAgregarParte = () => {

        const id = new Date().getUTCSeconds() + '' + new Date().getUTCMilliseconds();

        const tipoParteData = tipoParteArray.find( ( element ) => { return element.idTipoParte === tipoParte });

        if( nuevaParte ){
            
            if ( idPersona !== 0 ) {
                
                const personaValidate = rows.find( (e) => { return e.idPersona === idPersona && e.idTipoParte === tipoParteData?.idTipoParte });
                
                if ( !personaValidate ) {                      
    
                    const data: ParteProps = {
                        id: parseInt( id ),
                        idPersona: idPersona,
                        persona: nombreCompleto,
                        idTipoParte: tipoParteData?.idTipoParte ?? 0,
                        tipoParte: tipoParteData?.descripcion ?? '',
                        idTipoPersona: idTipoPersona,
                    };
    
                    setRows([...rows, data]);
                }
                else {

                    dispatch( openSnackbar({ message: `La persona ya se encuentra agregada como ${ ( personaValidate?.tipoParte ?? '' ) }`, variant: 'warning' }));  
                    return false;
                }
            }

        }
        else {

            const idPartePersona = arrayParte.find( ( elem ) => elem.id === parte )?.idPersona ?? 0;

            if( idPartePersona !== 0 ){

                const personaValidate =  rows.find( ( element ) => { return element.idPersona === idPartePersona });

                if( !personaValidate ){

                    const partePersona = arrayParte.find( ( elem ) => elem.id === parte );

                    if( parte === -1 ){      
                        
                        const data: ParteProps = {
                            id: parseInt( id ),
                            idPersona: partePersona?.idPersona ?? 0,
                            persona: partePersona?.persona ?? '',
                            idTipoParte: partePersona?.idTipoParte ?? 0,
                            tipoParte: partePersona?.tipoParte ?? '',
                            idTipoPersona: partePersona?.idTipoPersona ?? 0,
                        };
                
                        setRows( [ ...rows, data ] );
                    }
                    else {                            
                        
                        const data: ParteProps = {
                            id: parseInt( id ),
                            idPersona: partePersona?.idPersona ?? 0,
                            persona: partePersona?.persona ?? '',
                            idTipoParte: tipoParteData?.idTipoParte ?? 0,
                            tipoParte: tipoParteData?.descripcion ?? '',
                            idTipoPersona: partePersona?.idTipoPersona ?? 0,
                        };
                
                        setRows( [ ...rows, data ] );
                    }
                }
                else {
                    
                    dispatch( openSnackbar({ message: `La persona ya se encuentra agregada como ${ ( personaValidate?.tipoParte ?? '' ) }`, variant: 'warning' })); 
                    return false;
                }
            }

        }

        setPersona({ idPersona: 0, nombreCompleto: '', idTipoPersona: 0, });   
        setParte( 0 );
        setTipoParte(0);

    }

    const handleClicEditarParte = () => {

        const tipoParteData = tipoParteEditArray.find((element) => { return element.idTipoParte === tipoParteEdit });
        const personaExiste = rows.find( (e) => { return e.idPersona === idPersonaEdit && e.id !== idReferencia });

        if ( personaExiste ) {

            const personaValidate = rows.find( (e) => { return e.idPersona === idPersonaEdit && e.idTipoParte === tipoParteEdit });

            if( !personaValidate ){

                if ( personaExiste.idTipoParte === 1 && tipoParteData?.idTipoParte === 2 ) {

                    dispatch( openSnackbar({ message: 'La persona no puede agregarse como ' + ( tipoParteData?.descripcion ?? '' ), variant: 'warning' })); 
                    setOpenEdit( false );
                    
                    return false;
                }
                else if ( personaExiste.idTipoParte === 2 && tipoParteData?.idTipoParte === 1 ) {

                    dispatch( openSnackbar({ message: 'La persona no puede agregarse como ' + ( tipoParteData?.descripcion ?? '' ), variant: 'warning' })); 
                    setOpenEdit( false );
                    
                    return false;
                }
                else if (( personaExiste.idTipoParte === 7 && tipoParteData?.idTipoParte === 8 ) || ( personaExiste.idTipoParte === 8 && tipoParteData?.idTipoParte === 7 )) {

                    dispatch( openSnackbar({ message: 'La persona no puede agregarse como ' + ( tipoParteData?.descripcion ?? '' ), variant: 'warning' })); 
                    setOpenEdit( false );
                    
                    return false;
                }
                else if ( (personaExiste.idTipoParte === 1 && tipoParteData?.idTipoParte === 8 ) || ( personaExiste.idTipoParte === 7 && tipoParteData?.idTipoParte === 2 )) {
                    
                    dispatch( openSnackbar({ message: 'La persona no puede agregarse como ' + ( tipoParteData?.descripcion ?? '' ), variant: 'warning' })); 
                    setOpenEdit( false );
                    
                    return false;
                }
                else if (( personaExiste.idTipoParte === 2 && tipoParteData?.idTipoParte === 7 ) || ( personaExiste.idTipoParte === 8 && tipoParteData?.idTipoParte === 1 )) {
                    
                    dispatch( openSnackbar({ message: 'La persona no puede agregarse como ' + ( tipoParteData?.descripcion ?? '' ), variant: 'warning' })); 
                    setOpenEdit( false );
                    
                    return false;
                }
            }
            else {

                dispatch( openSnackbar({ message: `La persona ya se encuentra agregada como ${ ( tipoParteData?.descripcion ?? '' ) }`, variant: 'warning' })); 
                setOpenEdit( false );

                return false;
            }
        }
        
        var newArray = rows.filter(  (e) => e.id !== idReferencia );
        var editRow = rows.find( (e) => e.id === idReferencia );

        if( editRow ){

            var data: ParteProps = { ...editRow, idTipoParte: tipoParteData?.idTipoParte ?? 0 , tipoParte : tipoParteData?.descripcion ?? '' };
    
            setRows([ ...newArray, data ]);
            setOpenEdit( false );
        }

    }

    const handleClicRemoverParte = () => {

        var newArray = rows.filter( (e) => e.id !== idReferencia );

        setRows( newArray );
        setOpenConfirmacion( false );
    }

    const Guardar = async () => {

        const params: AgregarPartesAmparoParams = { 
            id: recepcion.id ?? '', 
            partes: rows,
        };

        const request = await AgregarPartesAmparo( params );  

        if( request.success ){
            dispatch( setReducerPartes({ partes: rows }) );
        }

        return request;
    }

    const handleGuardar = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingSave( true );

        await Guardar().then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingSave( false );

                }, 700);
            }
            else {

                setTimeout(() => {
                            
                    dispatch( openSnackbar({ message: message, variant: 'warning' })); 
                    setLoadingSave( false );

                }, 700);

            }

        });       

    }

    const handleRegresar = async () => {

        setLoadingBack( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){          
                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'warning' }));                     
                    setLoadingBack( false );
    
                }, 700);
            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 3 }).then( resp => {
        
            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleBack();
                    setLoadingBack( false );
                    
                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' })); 
                    setLoadingBack( false );

                }, 700);

            }

        });       

    }

    const handleSiguiente = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingNext( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){          
                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'warning' })); 
                    setLoadingNext( false );
    
                }, 700);
            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 6 }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingNext( false );
                    handleNext();

                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' })); 
                    setLoadingNext( false );

                }, 700);

            }

        });       

    }

    const handleChangeNuevaParte = ( value: boolean ) => {

        setPersona({ idPersona: 0, nombreCompleto: '', idTipoPersona: 0, });   
        setParte( 0 );
        setTipoParte( 0 );
        setNuevaParte( value ); 

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTipoParte().then( resp => {  
                setTipoParteArray( resp );    
                setTipoParteEditArray( resp );
            });

        }

        Obtener();

    }, [ ]);   

    useEffect(() => {
     
        if( recepcion.partes?.length !== 0 ){
            setRows( recepcion.partes ?? [] );
        }
        
    }, [ recepcion ])    

    useEffect(() => {

        async function Obtener(){

            await ObtenerPartesAmparo( recepcion?.id ?? '' ).then( resp => {               
                setArrayParte( resp );        
            });
        }
       
        Obtener();

    }, [ recepcion ]) 

    return (
        <Grid container spacing={3}>

            <Grid size={{ xs: 12, md: 12 }}>

                <Card sx={{ mt: 2 }}>
                
                    <CardHeader 
                        sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                        subheader={ 
                            <Grid container spacing={3}>

                                <Grid size={{ md: 6, xs: 6 }}>                                                                    
                                    <Typography variant='h6' sx={{ color: 'white' }}> Registrar parte(s) </Typography> 
                                </Grid>
                            
                                <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: 'end' }}>
                                    <Chip variant='filled' sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography>  } />
                                </Grid>

                            </Grid>
                        }
                    />
                    
                    {
                        !recepcion.acuseFirmado
                        &&
                            <CardContent sx={{ p: 3 }}>

                                <Grid container spacing={3} mt={1}>

                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <FormControl fullWidth>            

                                            <Grid container spacing={3}>

                                                <Grid size={{ md: 3, xs: 12 }} sx={{ alignContent: 'center'  }}>
                                                    <Typography fontWeight={'400'} variant='body2' fontSize={16}>Tipo de parte:</Typography>
                                                </Grid>
                                               
                                                <Grid size={{ md: 9, xs: 12 }}>

                                                    <RadioGroup row>   
                                                        
                                                        <Grid container spacing={3} sx={{ width: '100%' }}>

                                                            <Grid size={{ md: 6, xs: 12 }}>
                                                                <FormControlLabel value="No" control={ <Radio checked={ nuevaParte === false } onChange={ () => handleChangeNuevaParte( false ) } /> } label="Actor / Demandado / Autoridad" />                                                                   
                                                            </Grid>
                                                      
                                                            <Grid size={{ md: 6, xs: 12 }}>
                                                                <FormControlLabel value="Si" control={ <Radio checked={ nuevaParte === true } onChange={ () => handleChangeNuevaParte( true ) } /> } label="Otro" />       
                                                            </Grid>

                                                        </Grid>

                                                    </RadioGroup>                    

                                                </Grid>
                                                
                                            </Grid>                                               

                                        </FormControl>

                                    </Grid>

                                    {
                                        !nuevaParte
                                        &&
                                            <Grid size={{ md: 7, xs: 12 }}> 

                                                <FormControl fullWidth>
                                                    <InputLabel>Seleccione una persona</InputLabel>

                                                    <Select                                                                                          
                                                        label="Seleccione una persona"   
                                                        value={ parte }
                                                        onChange={ (e) => { 
                                                            setParte(e.target.value);  
                                                            if( e.target.value === -1 || e.target.value === 0 ){ setTipoParte( 0 ); }
                                                        }}                                                                       
                                                    >
                                                        <MenuItem value={0}>Selecciona una opción</MenuItem>                                     
                                                        {                                       
                                                            arrayParte                                          
                                                            .map( (e)=>(
                                                                <MenuItem key={ e.id } value={ e.id }> { e.persona.toLocaleUpperCase() }&nbsp;<strong>({ e.tipoParte })</strong> </MenuItem>
                                                            ))                                       
                                                        } 
                                                    </Select>

                                                </FormControl>

                                            </Grid>     
                                    }

                                    {
                                        nuevaParte
                                        &&
                                            <Grid size={{ md: 7, xs: 12 }}>
                                                <Paper component="div" sx={ InputSearchStyle }>

                                                    <InputBase
                                                        sx={{ ml: 1, flex: 1 }}
                                                        inputProps={{ 'aria-label': 'Buscar persona' }}
                                                        placeholder="Buscar persona"                                                    
                                                        autoComplete="off"
                                                        disabled
                                                        value={ nombreCompleto }
                                                    />

                                                    <Button
                                                        variant='contained'
                                                        size='small'
                                                        sx={ InputSearchButtonsStyle }
                                                        onClick={ () => setopenDialogBuscarPersona( true ) }
                                                    >
                                                        <SearchIcon />
                                                    </Button>

                                                    <Button
                                                        variant='contained'
                                                        size='small'
                                                        sx={ InputSearchButtonsStyle }
                                                        onClick={ () => setopenDialogNuevaPersona( true ) }
                                                    >
                                                        <PersonAddIcon />
                                                    </Button>

                                                </Paper>

                                            </Grid>
                                    }

                                    <Grid size={{ md: 5, xs: 12 }}>
                                        <FormControl fullWidth>
                                            <InputLabel>Tipo de parte</InputLabel>

                                            <Select                                          
                                                label="Tipo de parte"
                                                value={tipoParte}
                                                onChange={(e) => { setTipoParte(e.target.value); }}
                                                disabled={ ( !nuevaParte && ( parte === -1 || parte === 0 )) || ( nuevaParte && idPersona === 0 ) }  
                                            >
                                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                       
                                                {                            
                                                    tipoParteArray
                                                    .filter( (element ) => { return element.idTipoParte === 3 || element.idTipoParte === 4; } )
                                                    .map( ( element ) => (
                                                        <MenuItem key={ element.idTipoParte } value={ element.idTipoParte }>{ element.descripcion }</MenuItem>                                                        
                                                    ))
                                                }               
                                            </Select>

                                        </FormControl>
                                    </Grid>

                                    <Grid size={{ md: 12, xs: 12 }} textAlign={'end'}>
                                        <Button
                                            variant="contained"
                                            onClick={ handleClicAgregarParte }
                                            disabled={ 
                                                nuevaParte 
                                                ?
                                                    tipoParte === 0 || idPersona === 0 
                                                :
                                                    parte !== -1 && tipoParte === 0
                                            }
                                        >
                                            Agregar
                                        </Button>
                                    </Grid>

                                </Grid>

                            </CardContent>
                    }                
                                    
                </Card>  

            </Grid>

            <Grid size={{ md: 12, xs: 12 }}>

                <TableContainer sx={{ borderRadius: 3, mt: 1 }}>
                                       
                    <Table sx={{ minWidth: 500 }}>         

                        <TableHead sx={{ ...TableTheadStyle }}>

                            <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '50%' }}>Nombre</TableCell>
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%' }}>Tipo de parte</TableCell>
                                { !recepcion.acuseFirmado && <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}> </TableCell> }
                            </TableRow>

                        </TableHead>

                        <TableBody>

                            {
                                (
                                    rowsPerPage > 0
                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : rows
                                ).map( ( { id, idPersona, persona, idTipoParte, tipoParte, idTipoPersona }, index ) => (

                                    <TableRow key={ index } >
                                        <TableCell> { persona.toLocaleUpperCase() } </TableCell>
                                        <TableCell> { tipoParte } </TableCell>
                                        {
                                            !recepcion.acuseFirmado
                                            &&
                                                <TableCell sx={{ textAlign: 'end' }}>                                                    
                                                  
                                                    <IconButton 
                                                        color="primary" 
                                                        disabled={ idTipoParte === 5 }
                                                        onClick={ () => { setIdReferencia( id ); setTipoParteEdit( idTipoParte ); setIdPersonaEdit( idPersona ); setOpenEdit( true ); } }
                                                    >
                                                        <EditIcon />
                                                    </IconButton>                                                 
                                            
                                                    <IconButton sx={{ ml: 1 }} color="primary" onClick={ () => { setIdReferencia( id ); setOpenConfirmacion( true ); }}>
                                                        <DeleteIcon />
                                                    </IconButton>

                                                </TableCell>
                                        }
                                    </TableRow>

                                ))
                            }

                            {
                                rows.length === 0 &&
                                (
                                    <TableRow>
                                        <TableCell
                                            colSpan={6}
                                            align="center"
                                            style={{ fontWeight: 'bold', fontSize: 14 }}
                                        >
                                            <Typography variant="caption" color='secondary'> No se han agregado parte(s) </Typography>
                                        </TableCell>
                                    </TableRow>
                                )
                            }

                        </TableBody>

                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[]}
                                    colSpan={4}
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />
                            </TableRow>
                        </TableFooter>

                    </Table>

                </TableContainer>

            </Grid>

            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                <Grid container spacing={3}>

                    <Grid size={{ xs: 4, md: 4 }} style={{ textAlign: 'left' }}>
                        <IconButton
                            color='primary'
                            onClick={ handleRegresar }
                            loading={ loadingBack }
                        >
                            <GrPrevious />
                        </IconButton>
                    </Grid>

                    <Grid size={{ md: 4, xs: 4 }} sx={{ textAlign: 'center '}}>

                        {
                            !recepcion.acuseFirmado
                            &&
                                <Button 
                                    fullWidth
                                    variant="contained"
                                    onClick={ handleGuardar }
                                    loading={ loadingSave }
                                > 
                                    Guardar 
                                </Button>
                        }

                    </Grid>

                    <Grid size={{ xs: 4, md: 4 }} style={{ textAlign: 'right' }}>
                        <IconButton
                            color='primary'     
                            onClick={ handleSiguiente }
                            loading={ loadingNext }
                        >
                            <GrNext />
                        </IconButton>
                    </Grid>

                </Grid>

            </Grid>

            <Dialog                     
                maxWidth='xs' 
                fullWidth={true}
                disableEscapeKeyDown
                open={ openConfirmacion } 
                onClose={ () => { } } 
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText>
                        ¿Desea quitar el registro seleccionado?
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                    <Button onClick={ handleClicRemoverParte } variant='contained' > Aceptar </Button>
                </DialogActions>
            </Dialog>

            <Dialog 
                maxWidth='xs' 
                fullWidth={true}
                disableEscapeKeyDown
                open={ openEdit }                 
                onClose={ () => { } } 
            >
                <DialogTitle>
                    Editar
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Tipo de Parte</InputLabel>

                                <Select
                                    label="Tipo de Parte"
                                    value={tipoParteEdit}
                                    onChange={(e) => { setTipoParteEdit(e.target.value); }}
                                >
                                    <MenuItem value={0}>Selecciona una opción</MenuItem>                               
                                    {                                                                                      
                                        tipoParteEditArray
                                        .filter( (e) => e.idTipoParte === 3 || e.idTipoParte === 4 )
                                        .map( (e) => (
                                            <MenuItem key={e.idTipoParte} value={e.idTipoParte}>{e.descripcion}</MenuItem>
                                        ))    
                                    }                                  
                                </Select>

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary'  onClick={ () => setOpenEdit( false ) }> Cancelar </Button>
                    <Button onClick={ handleClicEditarParte } variant='contained' disabled={ tipoParteEdit === 0 }> Guardar </Button>
                </DialogActions>
            </Dialog>
            
            <DialogNuevaPersona 
                openDialog={ openDialogNuevaPersona } 
                handleCloseDialog={ () => setopenDialogNuevaPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona } 
                handleCloseDialog={ () => setopenDialogBuscarPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

        </Grid>
    )
}
